import React from 'react'
import Frontenddata from './Frontenddata'
import { BsGithub } from 'react-icons/bs';
import { HiLink } from "react-icons/hi";
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const Cardcontent = () => {

    const { ref, inView } = useInView();
    const animation3up = useAnimation();


    useEffect(() => {
        console.log("useeffect hook", inView);
        if (inView) {

            animation3up.start({
                y: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });
        }
        if (!inView) {

            animation3up.start({
                y: 60,
                opacity: 0,
            });
        }
    }, [inView]);

    const listItems = Frontenddata.map(({ id, src, title, description, tools, liveSite, repository }) =>
        <motion.li animate={animation3up} key={id}
            className='rounded-lg block overflow-hidden list-none space-y-4 h-fit bg-greyy bg-opacity-10 backdrop-filter backdrop-blur-xl'>
            <div className='transition-all relative overflow-hidden'>
                <img src={src} alt="se" className='w-full max-w-[100%] hover:scale-[1.03] transition-all duration-300' />
            </div>
            <div className=' p-4 md:p-8 space-y-8 '>
                <h2 className='text-[1.3em] items-center font-[700] mt-2 leading-none'>{title}</h2>
                <p className=''>{description}</p>
                <p>Tools: {tools}</p>
                <div className='justify-center lg:justify-start w-full flex gap-8 underline underline-offset-1'>
                    <a href={liveSite} target="_blank" className=' flex items-center gap-2 hover:-translate-y-1 transition-all'><HiLink
                    />Live Site</a>
                    <a href={repository} target="_blank" className='flex items-center gap-2 hover:-translate-y-1 transition-all'><BsGithub />Repository</a>
                </div>
            </div>
        </motion.li>
    )

    return (
        <ul ref={ref}
            className='space-y-8 md:space-y-0 lg:col-start-1 lg:col-end-5 md:grid md:grid-cols-2 md:gap-12'>
            {listItems}
        </ul>
    )
}

export default Cardcontent
